import { useLocation } from 'react-router-dom';
import { LANDING_V2 } from './landing.config';
import { ownsPath } from './routes.manifest';
import LandingRoutes from './LandingRoutes';

/**
 * The integration point. Wrap the host app's existing <Routes> with it:
 *
 *   <LandingSwitch>
 *     <Routes>
 *       ...every route you already have, untouched...
 *     </Routes>
 *   </LandingSwitch>
 *
 * With the flag OFF this renders its children and nothing else — the host
 * behaves exactly as it does today, byte for byte.
 *
 * With the flag ON, a URL the new site owns renders the new site instead of
 * the host's route table for that render. Everything else — /dashboard,
 * /billing, /main-admin, /partner, CRM, HRMS — still renders the host, because
 * those paths aren't in routes.manifest.js.
 *
 * Why a wrapper and not just another <Route path="/*">: React Router v6 ranks
 * routes by specificity, so the host's own "/" and "/login" would always beat
 * a catch-all mounted beside them, and the new site would never appear.
 * Deciding ownership before routing is what makes one flag genuinely switch
 * the site over.
 *
 * Must sit inside the host's <BrowserRouter> (it reads the location) and
 * inside <HelmetProvider> (the new pages set their own meta tags).
 */
export default function LandingSwitch({ children }) {
  const { pathname } = useLocation();

  if (!LANDING_V2) return children;
  if (!ownsPath(pathname)) return children;

  return <LandingRoutes />;
}
